import UserSearchBar from './UserSearchBar';

export default UserSearchBar;